import { CiLocationOn } from "react-icons/ci";
import { IoMailUnreadOutline } from "react-icons/io5";
import { MdOutlineMarkEmailRead, MdPhoneAndroid } from "react-icons/md";
import { PiBuildingApartment } from "react-icons/pi";
import { RiLink } from "react-icons/ri";
import { LuFactory } from "react-icons/lu";
import { LuUsers } from "react-icons/lu";
import CircleIcon from "../../../Assets/images/icons/circle-icon.png"
import orgData from './orgdata.json';
import { Row } from "react-bootstrap";
import Pagination from "../../../Components/formModules/Pagination";
import { useEffect, useRef, useState } from "react";
import Loader from "../../../Components/Loader";
import { FaLinkedin } from "react-icons/fa";
import { TbPhoneCheck } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { getMobileAccessStart } from "../../../Store/Slices/scrapperSlice";
import { formatLabel } from "../../../Components/DateFn";
import { IoMdRefresh } from "react-icons/io";
import { toast } from "react-toastify";
import Toast from "../../../Components/Toast";

const PhoneCell = ({ phoneNo, onRefresh }) => {
    const [loading, setLoading] = useState(false);
    const [timerFinished, setTimerFinished] = useState(false);

    const startTimer = () => {
        setLoading(true);
        setTimerFinished(false);

        const timer = setTimeout(() => {
            setLoading(false);
            setTimerFinished(true);
        }, 3 * 60 * 1000); // 3 * 60 * 1000

        return () => clearTimeout(timer);
    };

    useEffect(() => {
        if (!phoneNo) {
            const cleanup = startTimer();
            return cleanup;
        }
    }, [phoneNo]);

    const handleRefresh = async () => {
        setLoading(true);
        setTimerFinished(false);

        await onRefresh();

        if (!phoneNo) {
            startTimer();
        }
    };

    if (phoneNo) {
        return <span>{phoneNo}</span>;
    }

    if (loading) {
        return (
            <>
                <div className="text-blue-600">
                    Requested for phone no.
                </div>
                <div className="text-blue-600">
                    Please wait for few minutes
                </div>
            </>
        );
    }

    if (timerFinished) {
        return (
            <div>
                <span className="text-red-600">Phone no not available</span>{" "}
                <button
                    onClick={handleRefresh}
                    className="ml-2 border bg-gray-200 rounded hover:bg-gray-300"
                >
                    <IoMdRefresh />
                </button>
            </div>
        );
    }

    return null;
};

const CompanyTableData = ({
    error,
    selectedOption,
    _data,
    _totalCount,
    showFilterData,
    searchValue,
    currentPage,
    pageSize,
    setCurrentPage,
    setPageSize,
    setPaginationActivate,
    setSelectedDataToSave,
    selectedDataToSave
}) => {
    const dispatch = useDispatch();
    const selectAllRef = useRef(null);

    let scrapperData = useSelector((state) => state.scrapper);

    let [selectedRowId, setSelectedRowId] = useState('');
    let [accessDataList, setAccessDataList] = useState([
        // {
        //     id: '54a7369874686965d94e971f',
        //     email: "test@gmail.com",
        //     phone: ""
        // },
        // {
        //     id: '67bcc5e55af32700017118b9',
        //     email: "sample@gmail.com",
        //     phone: ""
        // }
    ]);

    useEffect(() => {
        if (scrapperData?.accessData) {
            const newItem = {
                id: scrapperData?.accessData?.[0]?.person_id,
                email: scrapperData?.accessData?.[0]?.email,
                phone: scrapperData?.accessData?.[0]?.phone
            };

            setAccessDataList(prevItems => {
                const alreadyExists = prevItems.some(item => item.id === newItem.id);
                if (!alreadyExists) {
                    return [...prevItems, newItem];
                }
                return prevItems;
            });

            // setAccessDataList(prevItems => [...prevItems, newItem]);
        }
    }, [scrapperData])

    useEffect(() => {
        if (error) {
            toast.error(error, {
                autoClose: 2000
            });
        }
    }, [error])

    // console.log('accessDataList?', accessDataList)

    const maskEmail = (email) => {
        const [localPart, domain] = email.split("@");
        const maskedLocal = "*".repeat(localPart.length);
        return `${maskedLocal}@${domain}`;
    };

    const maskPhoneNumber = (phone) => {
        const digitsOnly = phone.replace(/\D/g, "");
        const lastDigit = digitsOnly.slice(-1);
        return `+***_***_***k`;
        // return `+***_***_***${lastDigit}`;
    };

    const handlePageSizeChange = (size) => {
        setPaginationActivate(true);
        setPageSize(size);
        setCurrentPage(1);
    };

    const handlePrevPage = () => {
        setPaginationActivate(true);
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setPaginationActivate(true);
        let totalPages = Math.ceil(_totalCount / pageSize);
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    };

    const getAccessMobile = (row) => {
        setSelectedRowId(row?.id)
        let payload = {
            data: [{
                "first_name": row?.first_name,
                "last_name": row?.last_name,
                "organization_name": row?.organization?.name,
                "person_id": row?.id
            }]
        }
        dispatch(getMobileAccessStart(payload))
    }

    const handleSaveFilterData = (e, row) => {
        const isChecked = e.target.checked;

        if (isChecked) {
            setSelectedDataToSave(prev => {
                const exists = prev.some(item => item.id === row.id);
                return exists ? prev : [...prev, row];
            });
        } else {
            setSelectedDataToSave(prev =>
                prev.filter(item => item.id !== row.id)
            );
        }
    }

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedDataToSave(_data); // store full objects
        } else {
            setSelectedDataToSave([]);
        }
    };

    useEffect(() => {
        if (selectAllRef.current) {
            selectAllRef.current.indeterminate =
                selectedDataToSave?.length > 0 && selectedDataToSave?.length < _data?.length;
        }
    }, [selectedDataToSave, _data?.length]);

    const isAllSelected = selectedDataToSave?.length === _data?.length && _data?.length > 0;

    return (
        <>
            <Toast />
            {/* <Loader isVisible={true} isModal={true} overall={false} /> */}
            {/* <div className="fw-semibold fs-6 mt-2">{selectedOption}</div> */}
            <Row>
                <div className="col-4 d-flex align-items-center">
                    <p className="fw-semibold- text-secondary mb-0">
                        {showFilterData ?
                            <>
                                {_data?.filter(item => {
                                    if (!searchValue) return true
                                    if (item.first_name.includes(searchValue) ||
                                        item.last_name.includes(searchValue) ||
                                        item.title.includes(searchValue) ||
                                        item.organization.name.includes(searchValue) ||
                                        item.linkedin_url.includes(searchValue)
                                        // || item.company.location.includes(searchValue)
                                    ) {
                                        return true
                                    }
                                }).length
                                } result(s)
                                {/* 5 contacts from 1 company */}
                            </>
                            :
                            <></>
                        }
                    </p>
                </div>
                {/* <div className="col-8 datavault-pagination">
                    <div className="ag-theme-quartz" style={{ height: "auto", display: "flex", flexDirection: "column", position: "relative" }}>
                        <Pagination
                            className="border-0"
                            currentPage={currentPage}
                            pageSize={pageSize}
                            totalCount={5}
                        // onPageSizeChange={handlePageSizeChange}
                        // onPrevPage={handlePrevPage}
                        // onNextPage={handleNextPage}
                        />
                    </div>
                </div> */}
            </Row>
            <div className="tbl-container rounded-table mt-2">
                <div className="table-responsive">
                    <table className="table table-hover hover-icon-table users-table mb-0">
                        <thead>
                            <tr>
                                <th>
                                    <input className="form-check-input" type="checkbox"
                                        ref={selectAllRef}
                                        checked={isAllSelected}
                                        onChange={(e) => handleSelectAll(e)} />
                                </th>
                                <th className="w-30">Name</th>
                                <th className="w-30">Job Title</th>
                                <th className="w-20">Company</th>
                                <th className="w-30">Emails</th>
                                <th className="w-30">Phone</th>
                                {/* <th className="w-30">Link</th> */}
                                <th className="w-30">Location</th>
                                <th className="w-30">Departments</th>
                                <th className="w-30">Sub Departments</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!showFilterData && _data?.length > 0 ?
                                <>
                                    {_data?.filter(item => {
                                        if (!searchValue) return true
                                        if (item.first_name.includes(searchValue) ||
                                            item.last_name.includes(searchValue) ||
                                            item.title.includes(searchValue) ||
                                            item.organization.name.includes(searchValue)
                                            // || item.linkedin_url.includes(searchValue)
                                            // || item.company.location.includes(searchValue)
                                        ) {
                                            return true
                                        }
                                    })?.map((data, index) => {
                                        const match = accessDataList?.find(item => item.id === data.id);
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <input className="form-check-input" type="checkbox"
                                                        checked={selectedDataToSave?.some(item => item.id === data.id)}
                                                        onChange={(e) => handleSaveFilterData(e, data)} />
                                                </td>
                                                <td className="w-30">
                                                    <div>{data?.first_name} {data?.last_name}</div>
                                                </td>
                                                <td className="w-30">
                                                    <div>{data?.title}</div>
                                                </td>
                                                <td className="w-30">
                                                    <div>{data?.organization?.name}</div>
                                                </td>
                                                <td className="w-30">
                                                    {match ?
                                                        <div>{match?.email}</div>
                                                        : <button class="btn btn-light btn-blue me-2 border" type="button"
                                                            onClick={() => getAccessMobile(data)}>
                                                            <MdOutlineMarkEmailRead className="me-1" />
                                                            Access Email</button>
                                                    }
                                                </td>
                                                <td className="w-30">
                                                    {match ?
                                                        <>
                                                            <PhoneCell
                                                                phoneNo={match?.phone}
                                                                onRefresh={() => getAccessMobile(data)}
                                                            />
                                                            {/* {match?.phone ?
                                                                <div>{match?.phone}</div>
                                                                : <>
                                                                    <div>Requested for phone no</div>
                                                                    <div>Please wait for few minutes</div>
                                                                    <div><IoMdRefresh /></div>
                                                                </>
                                                            } */}
                                                        </>
                                                        : <button class="btn btn-light btn-blue me-2 border" type="button"
                                                            onClick={() => getAccessMobile(data)}>
                                                            <TbPhoneCheck className="me-1" />
                                                            Access Mobile</button>
                                                    }
                                                </td>
                                                {/* <td className="w-30">
                                                    <FaLinkedin title={data?.linkedin_url} />
                                                </td> */}
                                                <td className="w-30">
                                                    {/* <div>{data?.city} {data?.state} {data?.country}</div> */}
                                                    <div>{[data.city, data.state, data.country].filter(Boolean).join(', ')}</div>
                                                </td>
                                                <td className="w-30">
                                                    {/* <div>{data?.departments?.map((x) => formatLabel(x)).join(" ")}</div> */}
                                                    {data?.departments?.map((x) => (
                                                        <span className="dhub-table">{formatLabel(x)}</span>
                                                    ))}
                                                </td>
                                                <td className="w-30">
                                                    {/* <div>{data?.subdepartments?.map((x) => formatLabel(x)).join(" ")}</div> */}
                                                    {data?.subdepartments?.map((x) => (
                                                        <span className="dhub-table">{formatLabel(x)}</span>
                                                    ))}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </>
                                :
                                <tr>
                                    <td colSpan={7} className='text-center'>No Data Found</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    <div className="datavault-pagination">
                        <div className="ag-theme-quartz" style={{ height: "auto", display: "flex", flexDirection: "column", position: "relative" }}>
                            <Pagination
                                className="border-0"
                                currentPage={currentPage}
                                pageSize={pageSize}
                                totalCount={_totalCount}
                                onPageSizeChange={handlePageSizeChange}
                                onPrevPage={handlePrevPage}
                                onNextPage={handleNextPage}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default CompanyTableData;